import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { secondsToMilliseconds } from "date-fns";
import { incidentLogResponseSchema } from "features/CenterContent/RoleContent/ISirk/types";
import * as z from "zod";

export const useISirkLogMessages = (isirk: string) => {
  const { isError, isSuccess, data } = useQuery({
    queryKey: ["iSirkLogs", isirk],
    refetchInterval: secondsToMilliseconds(30),
    queryFn: async ({ signal }) =>
      axiosClient
        .get<
          z.infer<typeof incidentLogResponseSchema>
        >(`${getBackendUrl()}/alternative-transport/incident-logs?isirkIds=${isirk}&countryCode=NO`, { signal })
        .then((res) => incidentLogResponseSchema.parse(res.data)),
  });
  return { isError, isSuccess, data };
};
